import { Clock, User, LogOut } from 'lucide-react';
import { useState, useEffect } from 'react';

function formatTime(date, tz) {
  return date.toLocaleTimeString('en-US', {
    timeZone: tz,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export default function TopBar({ onLogout }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className="h-10 bg-korinth-surface border-b border-korinth-border flex items-center justify-between px-4">
      <div className="flex items-center gap-6 text-xs font-mono">
        <span className="text-korinth-muted flex items-center gap-1">
          <Clock className="w-3 h-3" />
          Dubai {formatTime(now, 'Asia/Dubai')}
        </span>
        <span className="text-korinth-muted">
          ET {formatTime(now, 'America/New_York')}
        </span>
        <span className="text-korinth-muted">
          UTC {formatTime(now, 'UTC')}
        </span>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5 text-xs">
          <div className="w-1.5 h-1.5 rounded-full bg-korinth-accent animate-pulse" />
          <span className="text-korinth-muted">Live</span>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-korinth-muted">
          <User className="w-3 h-3" />
          <span>Owner</span>
        </div>
        {onLogout && (
          <button
            onClick={onLogout}
            className="flex items-center gap-1 text-xs text-korinth-muted hover:text-korinth-danger transition-colors"
            title="Logout"
          >
            <LogOut className="w-3 h-3" />
          </button>
        )}
      </div>
    </header>
  );
}
